import {
  ShowIfTranslationExists,
  Translation,
  usePlatformConfig,
} from '@dxp-module/common'
import { Image } from '@dxp-module/mui-image'
import { Box, ClassNameMap, Typography } from '@mui/material'
import { FC } from 'react'
import { MaVehicleBannerClasses } from '@dxp-module/themes'
import clsx from 'clsx'
import useImageFromAssets from '../../hooks/useImageFromAssets'
import vehicleBannerStyles from './vehicleBanner.styles'

type VehicleBannerProps = {
  pageName: string
  title?: string
  description?: string
  classes?: Partial<ClassNameMap<MaVehicleBannerClasses>>
  imageFilename?: string
}

const VehicleBanner: FC<VehicleBannerProps> = ({
  pageName,
  title = '',
  description = '',
  classes,
  imageFilename,
}) => {
  const styles = vehicleBannerStyles()
  const image = useImageFromAssets(imageFilename)
  const {
    platformConfig: { myAccount },
  } = usePlatformConfig()
  const { vehicleBannerMinHeight } = myAccount || {}

  return (
    <Box className={styles.root}>
      <Image
        src={image}
        color="transparent"
        className={clsx([styles.imageContainer, classes?.imageContainer])}
        aspectRatio={4.8}
        disableTransition={true}
        imageStyle={{ objectFit: '', minHeight: vehicleBannerMinHeight ?? '200px' }}
        animationDuration={0}
        alt={imageFilename}
        data-test={`my-account:${pageName}:vehicle-banner`}
      />
      <Box className={styles.textContainer}>
        <ShowIfTranslationExists translationKey={title}>
          <Typography
            variant="h4"
            className={styles.title}
            data-test={`my-account:${pageName}:vehicle-banner:title`}
          >
            <Translation id={title} />
          </Typography>
        </ShowIfTranslationExists>
        <ShowIfTranslationExists translationKey={description}>
          <Typography
            component="span"
            className={styles.description}
            data-test={`my-account:${pageName}:vehicle-banner:description`}
          >
            <Translation id={description} />
          </Typography>
        </ShowIfTranslationExists>
      </Box>
    </Box>
  )
}

export default VehicleBanner
